<template>
	<b-container fluid>
		<page-title><h2 v-if="item"><router-link :to="{ name: 'InvoicePaymentTypeList' }" class="nav-link">Typy płatności</router-link>/Edycja</h2></page-title>

		<div class="col page-element">
			<div v-if="created" class="alert alert-success" role="status">{{ created['@id'] }} created.</div>
			<div v-if="updated" class="alert alert-success" role="status">{{ updated['@id'] }} updated.</div>
			<alert-loading v-if="retrieveLoading || updateLoading"></alert-loading>
			<div v-if="retrieveError" class="alert alert-danger" role="alert"><span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> {{ retrieveError }}</div>
			<div v-if="updateError" class="alert alert-danger" role="alert"><span class="glyphicon glyphicon-exclamation-sign" aria-hidden="true"></span> {{ updateError }}</div>

			<InvoicePaymentTypeForm v-if="item && !retrieveLoading && !updateLoading" :handle-submit="update" :values="item" :errors="violations" :initialValues="retrieved"></InvoicePaymentTypeForm>
		</div>
	</b-container>
</template>

<script>
  import InvoicePaymentTypeForm from './Form.vue';
  import { mapGetters } from 'vuex';

  export default {
    created () {
      this.$store.dispatch('invoicepaymenttype/update/retrieve', decodeURIComponent(this.$route.params.id));
    },
    components: {
      InvoicePaymentTypeForm
    },
    computed: {
      ...mapGetters({
        retrieveError: 'invoicepaymenttype/update/retrieveError',
        retrieveLoading: 'invoicepaymenttype/update/retrieveLoading',
        updateError: 'invoicepaymenttype/update/updateError',
        updateLoading: 'invoicepaymenttype/update/updateLoading',
        created: 'invoicepaymenttype/create/created',
        retrieved: 'invoicepaymenttype/update/retrieved',
        updated: 'invoicepaymenttype/update/updated',
        violations: 'invoicepaymenttype/update/violations'
      })
    },
    data: function() {
      return {
        item: {}
      }
    },
    methods: {
      update (values) {
        this.$store.dispatch('invoicepaymenttype/update/update', {item: this.retrieved, values: values });
      },
      reset () {
        this.$store.dispatch('invoicepaymenttype/update/reset');
        this.$store.dispatch('invoicepaymenttype/create/reset');
      }
    },
    beforeDestroy() {
      this.reset();
    }
  }
</script>



// WEBPACK FOOTER //
// Update.vue?2c8c61b4